module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1046-477128b9673f3ee2891a5fde403e1489.png";